<!-- 维修表单页面 -->
<template>
  <div
    class="repair-detail"
    v-track="{
      act: 'show',
      params: { cfrom: '01|01|080|001', type: repairType }
    }"
  >
    <!-- 内容区域 -->
    <div class="repair-detail-content" ref="repairDetail">
      <!-- 设备信息 -->
      <deviceInfo @showPricePopup="showPricePopup"></deviceInfo>
      <!-- 地址、时间等信息 -->
      <detailContent
        ref="detailContent"
        :isWeChatApp="isWeChatApp"
        :isSHowPolice="isShowHeader"
        :addressList="addressList"
        :isSupportQuick="isSupportQuick"
        @verifyPhone="verifyPhone"
        @selectedProvince="selectArea"
        @seeMoreSites="seeMoreSites"
        @selectRepairTime="selectRepairTime"
        @changeQuickRepairPhone="changeQuickRepairPhone"
        @selectPickupAddress="selectPickupAddress"
        @selectReciveAddress="selectReciveAddress"
        @changeRepairPhone="changeRepairPhone"
        @showImeiHelp="showImeiHelp"
        @changeSameAddress="mapLocationConfirm('isReciceAddress')"
        @changeService="changeService"
        @selectPhone="selectPhone"
      ></detailContent>
    </div>
    <div class="split-line" id="split-line"></div>
    <div :class="['bottom-bar-fixed', { 'bottom-bar': isInViewport }]">
      <div v-if="!shopOrder.shopOrderItemNo" class="bottom-button-left" @click="goBack">上一步</div>
      <div
        class="bottom-button-submit"
        :class="{ 'popup-button-disabled': !enableButton, 'all-line': shopOrder.shopOrderItemNo }"
        @click="submit"
      >
        提交
      </div>
    </div>
    <!-- 设备码查询方式弹窗 -->
    <serviceDialog ref="serviceDialog" :title="'设备码查询方式'">
      <imeiTip></imeiTip>
    </serviceDialog>
    <!-- 预约网点选择控件 -->
    <siteSelect ref="siteSelect" @selectPhone="selectPhone"></siteSelect>
    <!-- 时间选择 -->
    <timeSelect
      ref="timeSelect"
      @selectTimeConfirm="selectTimeConfirm"
      @setHomeSiteInfo="setHomeSiteInfo"
      @getRepairDefault="getRepairDefault"
    ></timeSelect>
    <!-- 地址选择 -->
    <addressSelect
      ref="addressSelect"
      :addressList="addressList"
      @addNewAddress="addNewAddress"
      @selectAddress="selectAddress"
      @deleteAddress="deleteCurrentAddress"
      @editAddress="editAddress"
    ></addressSelect>
    <!-- 地址增加 -->
    <addressAdd
      ref="addressAdd"
      @selectArea="selectArea"
      @goLocation="goLocation"
      @addressAddNewConfirm="addressAddNewConfirm"
      @addressUpdateConfirm="addressUpdateConfirm"
    ></addressAdd>
    <!-- 地址定位 -->
    <addressLocation
      ref="addressLocation"
      @quickSelectArea="quickSelectArea"
      @mapLocation="mapLocation"
      @selectConfirm="mapLocationConfirm"
    ></addressLocation>
    <!-- 地图选择 -->
    <mapSelect ref="mapSelect" :title="'定位地址'"></mapSelect>
    <!-- 省市区选择 -->
    <addressPicker
      v-if="addressData"
      @selectConfirm="selectConfirm"
      ref="addressPicker"
      :addressData="addressData"
      :title="'选择所在地区'"
    ></addressPicker>
    <!-- 服务切换弹窗 -->
    <serviceChange
      ref="serviceChange"
      @changeInit="init"
      @changeTitle="setTitle"
      :serviceChangeList="serviceChangeList"
    ></serviceChange>
    <!-- 价格弹窗 -->
    <servicePopup ref="pricePopup" :title="'预估总费用明细'">
      <pricePopup @hidePricePopup="hidePricePopup"></pricePopup>
    </servicePopup>
    <phoneSelect ref="phoneSelect" :phoneList="phoneList"></phoneSelect>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapState } from 'vuex'
import {
  checkCodeSend,
  deleteAddress,
  getProvince,
  getQuickPicupSite,
  queryAddress,
  repairChange,
  submitAppointmentOrder,
  submitOnsiteOrder,
  submitQuickPickupOrder,
  submitRepairOrder,
  getSendRepairAvailableSite,
  queryQuickAddressSupport,
  getShopRepairInfo
} from '../api'
import pricePopup from '../../base/wap/components/price-popup/index.vue'
import servicePopup from '@/components/service-popup/index.vue'
import serviceDialog from '@/components/service-dialog/index.vue'
import deviceInfo from './components/device-info/index.vue'
import detailContent from './components/detail-content/index.vue'
import timeSelect from './components/time-select/index.vue'
import addressSelect from './components/address-select/index.vue'
import addressAdd from './components/address-add/index.vue'
import mapSelect from './components/map-select/index.vue'
import imeiTip from './components/imei-tip/index.vue'
import addressPicker from './components/address-picker/index.vue'
import addressLocation from './components/address-location/index.vue'
import siteSelect from '@/views/repair/confirm/wap/components/site-select/index.vue'
import serviceChange from './components/service-change/index.vue'
import phoneSelect from './components/phone-select/index.vue'
import { isPhone } from 'utils/reg'
import toast from '@/utils/toast'
import clientEnv from '@/utils/clientEnv'
import app from 'utils/app'
import { Error } from '@vivo/vos-ui'
export default {
  name: 'repairBase',
  components: {
    servicePopup,
    siteSelect,
    serviceDialog,
    deviceInfo,
    pricePopup,
    detailContent,
    timeSelect,
    addressAdd,
    addressSelect,
    mapSelect,
    imeiTip,
    addressPicker,
    addressLocation,
    serviceChange,
    phoneSelect
  },
  data() {
    return {
      addressData: null,
      // 是否进入视口
      isInViewport: false,
      // 服务方式列表
      serviceChangeList: null,
      phoneList: [],
      begainTime: +new Date(),
      isSupportQuick: false
    }
  },
  computed: {
    // 维修类型（1-预约，2-寄修，3-上门维修，6-同城快修）
    ...mapState('repair', [
      'repairType',
      'addressSelectType',
      'addressList',
      'repairBeginTime',
      'selectedProblemList',
      'isReciceAddress',
      'selectedTime',
      'selectedModel',
      'currentAddress',
      'pickupAddress',
      'receiveAddress',
      'isSameAddress',
      'isAddressEdit',
      'quickRepairSendAddressInfo',
      'quickRepairReceiveAddressInfo',
      'appointmentOrder',
      'appointmentSite',
      'sendReapairSite',
      'homeReapairSite',
      'sendReapairOrderInfo',
      'homeReapairOrderInfo',
      'quickRepairOrderInfo',
      'QuickRepairSite',
      'isAgreed',
      'showPhoneVerification',
      'addressAddInfo',
      'userPhone',
      'isWeChatApp',
      'hasOldOrder',
      'userPhone',
      'appointmentAddress',
      'shopOrder',
      'submitToken'
    ]),
    isShowHeader() {
      return !clientEnv.isVivoApp && !this.isWeChatApp
    },
    enableButton() {
      if (this.repairType == 1) {
        // 定位中
        if (!(this.appointmentAddress && this.appointmentAddress.city)) {
          return false
        }

        return this.appointmentSite.siteCode
      }

      if (this.repairType == 2) {
        // 未选择地址时，不置灰
        if (!(this.pickupAddress && this.pickupAddress.receiverName)) {
          return true
        }
        return this.sendReapairSite.siteCode
      }

      if (this.repairType == 3) {
        // 未选择地址时，不置灰
        if (!(this.pickupAddress && this.pickupAddress.receiverName)) {
          return true
        }
        return this.homeReapairSite.siteCode
      }

      if (this.repairType == 6) {
        // 未选择地址时，不置灰
        if (!(this.quickRepairSendAddressInfo && this.quickRepairSendAddressInfo.receiverName)) {
          return true
        }
        return this.QuickRepairSite && this.QuickRepairSite.siteCode
      }

      return false
    }
  },
  created() {
    this.type = Number(this.$route.params.type)

    const shopOrderItemNo = this.$route.query.shopOrderItemNo
    const shopOrderNo = this.$route.query.shopOrderNo

    // 进入服务商品履约场景
    if (this.type && shopOrderItemNo && shopOrderNo) {
      if (this.type === 1 || this.type === 2) {
        // 保存商城订单号
        this.SET_SHOP_ORDER({
          shopOrderItemNo,
          shopOrderNo
        })
        // 保存维修类型
        this.SET_REPAIR_TYPE(this.type)
        // 进入页面
        this.setTitle()
        this.init()
      } else {
        // 维修类型不对直接跳转404
        location.href = 'https://www.vivo.com.cn/404'
      }
    } else {
      // 进入正常场景
      if (this.repairType) {
        if (
          this.repairType === 1 ||
          this.repairType === 2 ||
          this.repairType === 3 ||
          this.repairType === 6
        ) {
          this.setTitle()
          this.init()
        } else {
          // 维修类型不对直接跳转404
          location.href = 'https://www.vivo.com.cn/404'
        }
      } else {
        // 不存在时根据 url 参数跳转会首页
        this.$router.back()
      }
    }
  },
  mounted() {},
  methods: {
    ...mapMutations('repair', [
      'SET_SELECTED_TIME',
      'SET_ADDRESS_LIST',
      'SET_APPOINTMENT_ADDRESS',
      'setMapLocationPickupAddress',
      'setIsAddressEdit',
      'setAddressAddInfo',
      'setMapLocationReceiveAddress',
      'setQuickRepairSite',
      'setAddressAddALLInfo',
      'setAppointmentOrderPhone',
      'setAppointmentCheckPhone',
      'setShowPhoneVerification',
      'setIsReciceAddress',
      'setSendReapairSite',
      'setIsSameAddress',
      'setPickupAddress',
      'setReceiveAddress',
      'SET_DISTRIBUTION_FEE_DATA',
      'setHomeReapairSite',
      'SET_CALENDAR_FLAG',
      'SET_CURRENT_ADDRESS',
      'SET_SHOP_ORDER',
      'SET_SHOP_ORDER_INFO',
      'SET_REPAIR_TYPE'
    ]),
    ...mapActions('repair', [
      'getNearLocation',
      'getTimeList',
      'getSiteList',
      'getAddressList',
      'aMapConvertFrom',
      'aMapGetAddress',
      'processLocationData',
      'getSubmitToken'
    ]),

    // 页面初始化
    async init(tips, resetPosition) {
      this.submitToken || this.getSubmitToken()
      if (this.shopOrder.shopOrderItemNo) {
        // 进入服务商品履约场景
        await getShopRepairInfo({
          shopOrderItemNo: this.shopOrder.shopOrderItemNo
        })
          .then(res => {
            if (res.code == 0 && res.data) {
              const tips = res.data.submitCheck
              this.SET_SHOP_ORDER_INFO(res.data)

              if (tips) {
                toast(tips)
              }
            } else {
              toast(res.msg)
            }
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        // 正常维修场景
        // 如果没有选择型号或者故障类型直接返回
        if (!this.selectedModel.id || !this.selectedProblemList.id) {
          this.$router.push(`/service/s/repair/base/${this.repairType}`)
          return
        }
      }

      if (tips) {
        toast(tips)
      }

      // 同城切预约时，使用同城第一个地址的省市区和经纬度，不走定位
      if (this.repairType == 1 && resetPosition) {
        // 修改当前定位和经纬度，非必要不要执行这个操作，会更改用户的当前定位
        this.SET_CURRENT_ADDRESS(this.quickRepairSendAddressInfo.mapLocationPickupAddress)
        this.SET_APPOINTMENT_ADDRESS(this.quickRepairSendAddressInfo.mapLocationPickupAddress)
        this.getSiteList()
      } else {
        // 获取定位信息
        await this.getLocation()
          .then(async res => {
            if (res) {
              // 获取官网 APP 定位成功 -> GPS 坐标转换为高德坐标
              await this.aMapConvertFrom(res).then(async lngLat => {
                if (lngLat) {
                  // 高德坐标获取地址信息
                  await this.aMapGetAddress(lngLat).then(location => {
                    if (location) {
                      const data = Object.assign(location, {
                        position: lngLat[0]
                      })
                      // 处理得到的地址信息
                      this.processLocationData(data)
                    } else {
                      // 没有地址信息按定位失败处理
                      this.processLocationData(null)
                    }
                  })
                } else {
                  // 获取定位失败
                  this.processLocationData(null)
                }
              })
            } else {
              // 官网 APP 内直接按失败处理，非官网 APP 使用高德定位
              clientEnv.isVivoApp ? this.processLocationData(null) : await this.getNearLocation()
            }
          })
          .catch(err => {
            console.log(err)
            // 获取定位失败
            this.processLocationData(null)
          })
      }
      // 预约和上门会选择网点后调时间接口
      if (this.repairType != 3 && this.repairType != 1) {
        await this.getTimeList()
      }
      // 获取地址列表
      await this.getAddressList()
      // 预约无需调用地址接口
      if (this.repairType == 3 && !this.pickupAddress.receiverName) {
        await this.getAddressDefault()
      }
      // 获取省市区接口
      this.getProvinceData()
      // 返回上一页在进入页面判断是否有手机号填写
      if (this.repairType == 1 && isPhone(this.appointmentOrder.userPhone)) {
        this.checkChangePhone(this.appointmentOrder.userPhone)
      }
      // 不展示头尾的话，不需要监听
      if (this.isShowHeader) {
        // 监听是否进入视口
        const observer = new IntersectionObserver(this.handleIntersection)
        // 监视目标元素
        observer.observe(document.querySelector('#split-line'))
      } else {
        this.isInViewport = false
      }
    },
    // 解决寄修初始进入页面没有时间的无法获取网点的问题
    async getRepairDefault() {
      if (this.repairType == 2 && !this.pickupAddress.receiverName) {
        await this.getAddressDefault()
      }
    },
    selectPhone(phoneList) {
      this.phoneList = phoneList
      this.$nextTick(() => {
        this.$refs.phoneSelect.openPopup()
      })
    },
    getLocation() {
      return new Promise(resolve => {
        app.getLocation(
          res => {
            console.log(res)
            if (res.longitude && res.latitude) {
              // 获取官网 APP 定位成功
              resolve([res.longitude, res.latitude])
            } else {
              // 获取官网 APP 定位失败
              resolve(null)
            }
          },
          () => {
            // 不在官网 APP 内
            resolve(null)
          }
        )
      })
    },
    setTitle() {
      setTimeout(() => {
        if (this.repairType == 1) {
          document.title = '预约服务'
        } else if (this.repairType == 2) {
          document.title = '寄修服务'
        } else if (this.repairType == 3) {
          document.title = '上门维修'
        } else if (this.repairType == 6) {
          document.title = '同城快修'
        }
      }, 50)
    },
    // 监听元素是否在视口中
    handleIntersection(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.isInViewport = true
          // 在视口中的逻辑处理
        } else {
          const element = document.getElementById('split-line')
          const distanceToTop = element && element.getBoundingClientRect()?.top
          // 从视口上面离开
          if (distanceToTop > 10) {
            this.isInViewport = false
            // 不在视口中的逻辑处理
          }
        }
      })
    },
    async getChangeServiceData() {
      // 接口异常不展示
      // this.$nextTick(() => {
      //   this.$refs.serviceChange.openPopup()
      // })
      // 预约切换其他服务 - 寄修和同城不支持的地址不可以选择（地址簿逻辑），所以不会展示切换服务模块
      let params = {
        provinceName: this.addressAddInfo.province,
        cityName: this.addressAddInfo.city,
        areaName: this.addressAddInfo.area,
        productId: this.selectedModel.id,
        faultTypeId: this.selectedProblemList.id,
        // 服务商品履约标识，有此标识写死预约、寄修支持，其他不支持
        shopType: this.shopOrder.shopOrderItemNo ? 1 : undefined
      }
      // 同城快修切换其他服务，判断预约支不支持用同城的第一个地址省市区和经纬度
      if (this.repairType == 6) {
        params = {
          provinceName: this.quickRepairSendAddressInfo.mapLocationPickupAddress.province,
          cityName: this.quickRepairSendAddressInfo.mapLocationPickupAddress.city,
          areaName: this.quickRepairSendAddressInfo.mapLocationPickupAddress.area,
          productId: this.selectedModel.id,
          faultTypeId: this.selectedProblemList.id,
          longitude: this.quickRepairSendAddressInfo.mapLocationPickupAddress.lng || undefined,
          latitude: this.quickRepairSendAddressInfo.mapLocationPickupAddress.lat || undefined,
          // 服务商品履约标识，有此标识写死预约、寄修支持，其他不支持
          shopType: this.shopOrder.shopOrderItemNo ? 1 : undefined
        }
      }

      let res = await repairChange(params)
      if (res.code == 0) {
        this.serviceChangeList = res.data
        return true
      } else {
        toast(res.msg)
      }
    },
    // 切换服务方式
    async changeService() {
      try {
        const res = await this.getChangeServiceData()
        if (res) {
          this.$nextTick(() => {
            this.$refs.serviceChange.openPopup()
          })
        }
      } catch (error) {
        // 服务异常弹窗展示
        Error.show({
          onRefresh: () => {
            location.reload()
          }
        })
      }
    },
    // 查看更多网点
    seeMoreSites() {
      this.$nextTick(() => {
        this.$refs.siteSelect.openPopup()
      })
    },
    // 展示设备码查询方式
    showImeiHelp() {
      this.$nextTick(() => {
        this.$refs.serviceDialog.openDialog()
      })
    },
    // 获取维修时间
    async selectRepairTime() {
      this.$nextTick(() => {
        this.$refs.timeSelect.openPopup()
      })
    },
    // 选择取件地址
    async selectPickupAddress() {
      this.setIsReciceAddress(false)
      // 维修类型（1-预约，2-寄修，3-上门维修，6-同城快修）
      if (this.repairType == 6) {
        this.$nextTick(() => {
          this.$refs.addressLocation.openPopup()
        })
      } else {
        // 没有地址直接添加地址
        if (this.addressList.length == 0) {
          this.$nextTick(() => {
            this.$refs.addressAdd.openPopup()
          })
        } else {
          this.$nextTick(() => {
            this.$refs.addressSelect.openPopup()
          })
        }
      }
    },
    changeQuickRepairPhone() {
      this.$refs.addressLocation.openPopup()
      this.$nextTick(() => {
        this.$refs.addressLocation.setPickupAddress()
        this.$refs.addressLocation.mobilePhoneFocus()
      })
    },
    // 选择收件地址
    async selectReciveAddress() {
      this.setIsReciceAddress(true)
      if (this.repairType == 6) {
        this.$refs.addressLocation.openPopup()
      } else {
        this.$refs.addressSelect.openPopup()
      }
    },
    changeRepairPhone() {
      this.$nextTick(() => {
        // 修改电话，先复制
        this.setAddressAddALLInfo(this.pickupAddress)
        this.$refs.addressAdd.openPopup()
        this.$refs.addressAdd.phoneFocus()
      })
    },
    getAddressDefault() {
      if (this.addressList && this.addressList.length) {
        const defaultAddress = this.addressList.filter(item => item.isDefault == true)[0]
        if (defaultAddress && defaultAddress.addressSupport) {
          this.setPickupAddress(defaultAddress)
          // 寄修获取网点，上门维修获取时间
          if (this.repairType == 2 && this.selectedTime.time) {
            this.getSendRepairSite(defaultAddress)
          }
          if (this.repairType == 3) {
            this.getTimeList()
          }
        } else {
          this.setPickupAddress({})
        }
      }
    },
    // 吊起省市区
    quickSelectArea() {
      this.selectArea()
    },
    // 吊起定位地址
    mapLocation() {
      this.$nextTick(() => {
        this.$refs.mapSelect.openPopup()
      })
    },
    // 同城快修选择定位地址
    async mapLocationConfirm(status) {
      this.queryQuickPicupSite(status)
    },
    // 验证是否是本人手机号
    async checkChangePhone(phoneNum) {
      if (!phoneNum) {
        return
      }

      // 如果不是账户关联手机号，直接展示验证码
      if (this.userPhone && phoneNum.trim() !== this.userPhone) {
        this.setShowPhoneVerification(1)
        return
      }

      const params = {
        mobile: phoneNum.trim(),
        // 账号关联手机号每天有 10 次不需要验证码就可以提交的逻辑
        // type 0: 查询是否需要手机验证码; 1: 手动使验证码使用次数 +1
        type: 0
      }
      let res = await checkCodeSend(params)
      if (res.code == 0) {
        // 不需要填写验证码时清空现有验证码
        if (!res.data) {
          switch (String(this.repairType)) {
            case '1':
              this.appointmentOrder.smsCode = ''
              break
            case '2':
              this.sendReapairOrderInfo.smsCode = ''
              break
            case '3':
              this.homeReapairOrderInfo.smsCode = ''
              break
            case '6':
              this.quickRepairOrderInfo.smsCode = ''
              break
          }
        }
        this.$nextTick(() => {
          // 展示手机验证码，false 不需要填写验证码 true 需要填写验证码
          this.setShowPhoneVerification(res.data)
        })
      } else {
        toast(res.msg)
      }
    },
    changeUserPhoneLimited(userPhone) {
      checkCodeSend({
        mobile: userPhone,
        // 账号关联手机号每天有 10 次不需要验证码就可以提交的逻辑
        // type 0: 查询是否需要手机验证码; 1: 手动使验证码使用次数 +1
        type: 1
      })
    },
    // 获取网点地址
    async queryQuickPicupSite(status) {
      let params = {}
      if (this.repairType == 6 && this.selectedTime.showTime) {
        if (this.isSameAddress && this.quickRepairSendAddressInfo) {
          // 查询当前城市是否支持同城 - 相同地址
          queryQuickAddressSupport({
            province: this.quickRepairSendAddressInfo.mapLocationPickupAddress.province,
            city: this.quickRepairSendAddressInfo.mapLocationPickupAddress.city,
            provinceTwo: this.quickRepairSendAddressInfo.mapLocationPickupAddress.province,
            cityTwo: this.quickRepairSendAddressInfo.mapLocationPickupAddress.city
          }).then(res => {
            if (res.code == 0) {
              const data = res.data
              this.isSupportQuick = Boolean(data && data.addressSupport && data.addressTwoSupport)
            }
          })

          // 查询同城网点
          params = {
            productId: this.selectedModel.id,
            // productId: 774,
            pickupLongitude: this.quickRepairSendAddressInfo.mapLocationPickupAddress.lng,
            pickupLatitude: this.quickRepairSendAddressInfo.mapLocationPickupAddress.lat,
            pickupAddress: this.quickRepairSendAddressInfo.detailAddress,
            radius: 5000,
            pickUpTime: this.selectedTime.time,
            sendLongitude: this.quickRepairSendAddressInfo.mapLocationPickupAddress.lng,
            sendLatitude: this.quickRepairSendAddressInfo.mapLocationPickupAddress.lat,
            sendAddress: this.quickRepairSendAddressInfo.detailAddress
          }
          let res = await getQuickPicupSite(params)
          if (res.code == 0 && res.data) {
            // 如果是收货地址无需匹配网点，网点只匹配寄出地址
            if (!this.isReciceAddress && status != 'isReciceAddress') {
              this.setQuickRepairSite(res.data)
            }
            let feeObj = {
              // 是否填写了地址信息
              isAddressFilled: true,
              // 寄出费用
              shippingFee: res.data.pickupFee,
              // 寄回费用
              returnShippingFee: res.data.sendFee,
              // 配送总费用
              totalShippingFee: (
                Number(this.QuickRepairSite.pickupFee) + Number(this.QuickRepairSite.sendFee)
              ).toFixed(2)
            }
            this.SET_DISTRIBUTION_FEE_DATA(feeObj)
            this.checkChangePhone(this.quickRepairSendAddressInfo.mobilePhone)
          } else {
            this.checkChangePhone(false)
            if (!this.isReciceAddress && status != 'isReciceAddress') {
              this.setQuickRepairSite(res.data)
            }
          }
        } else if (
          !this.isSameAddress &&
          this.quickRepairSendAddressInfo &&
          this.quickRepairReceiveAddressInfo
        ) {
          // 查询当前城市是否支持同城 - 不同地址
          queryQuickAddressSupport({
            province: this.quickRepairSendAddressInfo.mapLocationPickupAddress.province,
            city: this.quickRepairSendAddressInfo.mapLocationPickupAddress.city,
            provinceTwo: this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.province,
            cityTwo: this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.city
          }).then(res => {
            if (res.code == 0) {
              const data = res.data
              this.isSupportQuick = Boolean(data && data.addressSupport && data.addressTwoSupport)
            }
          })

          // 查询同城网点
          params = {
            productId: this.selectedModel.id,
            pickupLongitude: this.quickRepairSendAddressInfo.mapLocationPickupAddress.lng,
            pickupLatitude: this.quickRepairSendAddressInfo.mapLocationPickupAddress.lat,
            pickupAddress: this.quickRepairSendAddressInfo.detailAddress,
            radius: 5000,
            pickUpTime: this.selectedTime.time,
            sendLongitude: this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.lng,
            sendLatitude: this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.lat,
            sendAddress: this.quickRepairReceiveAddressInfo.detailAddress
          }
          let res = await getQuickPicupSite(params)
          if (res.code == 0 && res.data) {
            // 如果是收货地址无需匹配网点，网点只匹配寄出地址
            if (!this.isReciceAddress && status != 'isReciceAddress') {
              this.setQuickRepairSite(res.data)
            }
            let feeObj = {
              // 是否填写了地址信息
              isAddressFilled: true,
              // 寄出费用
              shippingFee: res.data.pickupFee,
              // 寄回费用
              returnShippingFee: res.data.sendFee,
              // 配送总费用
              totalShippingFee: (
                Number(this.QuickRepairSite.pickupFee) + Number(this.QuickRepairSite.sendFee)
              ).toFixed(2)
            }
            this.SET_DISTRIBUTION_FEE_DATA(feeObj)
            this.checkChangePhone(this.quickRepairSendAddressInfo.mobilePhone)
          } else {
            this.checkChangePhone(false)
            if (!this.isReciceAddress && status != 'isReciceAddress') {
              this.setQuickRepairSite(res.data)
            }
          }
        }
      }
    },
    // 添加收货地址
    addNewAddress() {
      // this.$refs.addressSelect.closePopup()
      this.setIsAddressEdit(false)
      // this.getProvinceData()
      this.$nextTick(() => {
        this.$refs.addressAdd.openPopup()
      })
    },
    // 选择收货地址
    selectAddress(item) {
      // 上门维修获取网点在选择时间的时候
      if (this.repairType == 3) {
        this.setPickupAddress(item)
        this.setHomeReapairSite({})
        this.getTimeList()
      } else {
        if (this.isReciceAddress) {
          this.setReceiveAddress(item)
        } else {
          this.setPickupAddress(item)
          this.getSendRepairSite(this.pickupAddress)
        }
      }
    },
    // 删除收货地址
    async deleteCurrentAddress(item, isSelect) {
      let params = {
        id: item.id
      }
      let res = await deleteAddress(params)
      if (res.code == 0) {
        toast('删除成功')
        // 根绝是否删除选中删除已选中的地址
        if (isSelect) {
          if (this.isReciceAddress) {
            if (this.pickupAddress.id == this.receiveAddress.id) {
              this.setPickupAddress({})
              this.setSendReapairSite({})
            }
            this.setReceiveAddress({})
          } else {
            if (this.pickupAddress.id == this.receiveAddress.id) {
              this.setReceiveAddress({})
            }
            this.setPickupAddress({})
            this.setSendReapairSite({})
            if (this.repairType == 3) {
              this.SET_SELECTED_TIME({})
              this.setHomeReapairSite({})
            }
          }
        }
        this.getAddressList()
      } else {
        toast(res.msg)
      }
    },
    // 编辑收货地址
    editAddress() {
      this.setIsAddressEdit(true)
      // // 先关闭地址列表弹窗在弹窗编辑弹窗
      // this.$refs.addressSelect.closePopup()
      this.$nextTick(() => {
        this.$refs.addressAdd.openPopup()
      })
    },
    // 校验手机号
    verifyPhone(phone) {
      this.checkChangePhone(phone)
      this.setAppointmentCheckPhone(phone)
    },
    // 新建新增地址确认
    async addressAddNewConfirm(currenId) {
      const params = {
        type: this.repairType
      }
      let res = await queryAddress(params)
      if (res.code == 0) {
        this.SET_ADDRESS_LIST(res.data)
        if (res.data && res.data.length) {
          const currentAddress = res.data.filter(item => item.id == currenId)[0]
          if (this.repairType == 2) {
            if (this.isReciceAddress) {
              this.setReceiveAddress(currentAddress)
              this.getSendRepairSite(currentAddress)
            } else {
              if (currentAddress && currentAddress.addressSupport) {
                this.setPickupAddress(currentAddress)
                this.getSendRepairSite(currentAddress)
              } else {
                toast('当前地址不支持，请选择其他地址')
                this.setPickupAddress({})
                this.setSendReapairSite({})
              }
            }
          } else {
            if (currentAddress && currentAddress.addressSupport) {
              // 判断是收货还是取货
              if (this.isReciceAddress) {
                this.setReceiveAddress(currentAddress)
              } else {
                this.setPickupAddress(currentAddress)
              }
              this.getTimeList()
            } else {
              toast('当前地址不支持，请选择其他地址')
              if (this.isReciceAddress) {
                this.setReceiveAddress({})
              } else {
                this.setPickupAddress({})
              }
              this.setSendReapairSite({})
            }
          }
          this.$nextTick(() => {
            this.setIsAddressEdit(false)
            this.$refs.addressAdd.closePopup()
            this.$refs.addressSelect.closePopup()
          })
        }
      }
    },
    // 更新地址确认
    async addressUpdateConfirm() {
      const params = {
        type: this.repairType
      }
      let res = await queryAddress(params)
      if (res.code == 0) {
        this.SET_ADDRESS_LIST(res.data)
        const currentAddress = res.data.filter(item => item.id == this.addressAddInfo.id)[0]
        if (this.repairType == 2) {
          if (this.isReciceAddress) {
            this.setReceiveAddress(currentAddress)
          } else {
            if (currentAddress && currentAddress.addressSupport) {
              this.setPickupAddress(currentAddress)
              this.getSendRepairSite(currentAddress)
            } else {
              toast('当前地址不支持，请选择其他地址')
              this.setPickupAddress({})
              this.setSendReapairSite({})
            }
          }
        } else if (this.repairType == 3) {
          this.setPickupAddress(currentAddress)
          this.getTimeList()
        } else {
          if (currentAddress && currentAddress.addressSupport) {
            // 判断是收货还是取货
            if (this.isReciceAddress) {
              this.setReceiveAddress(currentAddress)
            } else {
              this.setPickupAddress(currentAddress)
            }
            this.getTimeList()
          } else {
            toast('当前地址不支持，请选择其他地址')
            if (this.isReciceAddress) {
              this.setReceiveAddress({})
            } else {
              this.setPickupAddress({})
            }
            this.setSendReapairSite({})
          }
        }
        this.$nextTick(() => {
          this.setIsAddressEdit(false)
          this.$refs.addressAdd.closePopup()
          this.$refs.addressSelect.closePopup()
          // setTimeout(() => {
          //   this.$refs.addressSelect.closePopup()
          // }, 10)
        })
      }
    },
    // 省市区选择确认
    async selectConfirm(result) {
      // 地址更新或者新增更新数据
      this.setAddressAddInfo(result)
      // 预约直接选择省市区
      if (this.repairType == 1) {
        this.SET_APPOINTMENT_ADDRESS(result)
        // 预约选择省市区
        await this.getSiteList()
      }
      // 同城快修选择省市区
      if (this.repairType == 6) {
        if (this.addressSelectType == 1) {
          this.setMapLocationPickupAddress(result)
        } else {
          this.setMapLocationReceiveAddress(result)
        }
      }
    },
    bd_decrypt(bd_lon, bd_lat) {
      let X_PI = (Math.PI * 3000.0) / 180.0
      let x = bd_lon - 0.0065
      let y = bd_lat - 0.006
      let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * X_PI)
      let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * X_PI)
      let gg_lon = z * Math.cos(theta)
      let gg_lat = z * Math.sin(theta)
      return {
        gg_lon,
        gg_lat
      }
    },
    setHomeSiteInfo(item) {
      // 上门维修地址变动后获取时间
      if (this.repairType == 3) {
        let bdDecrypt = this.bd_decrypt(item.longitude, item.latitude)
        let homeSiteInfo = {
          address: item.address,
          businessTime: item.businessTime,
          newPhone: item.newPhone,
          siteName: item.siteName,
          time: item.time,
          restTime: item.restTime,
          siteCode: item.siteCode,
          latitude: bdDecrypt.gg_lat,
          longitude: bdDecrypt.gg_lon
        }
        // 获取上门维修网点
        this.setHomeReapairSite(homeSiteInfo)
        // 如果有网点则校验手机号
        if (item.siteCode) {
          this.checkChangePhone(this.pickupAddress.mobilePhone)
        }
      }
    },
    // 时间选择确认
    selectTimeConfirm() {
      // 寄修时间修改也需要获取网点接口
      if (
        this.repairType == 2 &&
        this.pickupAddress.province &&
        this.pickupAddress.city &&
        this.pickupAddress.area
      ) {
        this.getSendRepairSite(this.pickupAddress)
      } else {
        this.queryQuickPicupSite()
      }
    },
    // 获取寄修网点
    async getSendRepairSite(pickupAddress) {
      // if (!this.selectedTime.time) {
      //   await this.getTimeList()
      // }
      let params = {
        province: pickupAddress.province,
        city: pickupAddress.city,
        area: pickupAddress.area,
        receiveTime: this.selectedTime.time
      }
      let res = await getSendRepairAvailableSite(params)
      if (res.code === 0) {
        if (res.data && res.data.id) {
          // 如果是收货地址无需匹配网点，网点只匹配寄出地址
          if (!this.isReciceAddress) {
            this.setSendReapairSite(res.data)
          }
          this.checkChangePhone(this.pickupAddress.mobilePhone)
        } else {
          // 如果是收货地址无需匹配网点，网点只匹配寄出地址
          if (!this.isReciceAddress) {
            this.setSendReapairSite({})
          }
          this.checkChangePhone(false)
        }
      }
    },
    // 展示价格弹层
    showPricePopup() {
      this.$nextTick(() => {
        this.$refs.pricePopup.openPopup()
      })
    },
    // 隐藏价格弹层
    hidePricePopup() {
      this.$nextTick(() => {
        this.$refs.pricePopup.closePopup()
      })
    },
    // 获取省市区接口
    async getProvinceData() {
      const params = {
        type: this.repairType,
        productId: this.selectedModel.id
      }
      let res = await getProvince(params)
      if (res.code == 0) {
        this.addressData = res.data
      }
    },
    // 选择地址
    async selectArea() {
      if (this.addressData) {
        this.$nextTick(() => {
          this.$refs.addressPicker.openPopup()
        })
      } else {
        await this.getProvinceData()
        this.$nextTick(() => {
          this.$refs.addressPicker.openPopup()
        })
      }
    },

    goLocation() {
      this.$nextTick(() => {
        this.$refs.mapSelect.openPopup()
      })
    },
    /**
     * 预约成功后，给官网APP添加日历
     */
    addCalendarEvent() {
      let reservationDate = this.selectedTime.day.toString().replace(/-/g, '/')
      let reservationDuringTime = this.selectedTime.newTimeslot.split('-')
      let reservationStartTime =
        reservationDate + ' ' + reservationDuringTime[0].split(' ').join('')
      let reservationEndTime = reservationDate + ' ' + reservationDuringTime[1].split(' ').join('')
      let web_calendar_start_time = new Date(reservationStartTime.toString()).getTime()
      let web_calendar_end_time = new Date(reservationEndTime.toString()).getTime()
      this.SET_CALENDAR_FLAG(0)

      window.setCalendarEventCallback = (a, b, c) => {
        if (a || b || c) {
          this.SET_CALENDAR_FLAG(1)
        }
      }

      const params = {
        web_calendar_title: this.appointmentSite.siteName + '预约服务',
        web_calendar_description: ' ',
        web_calendar_start_time,
        web_calendar_end_time,
        web_calendar_reminder_time: '5',
        web_calendar_reminder_method: '-1'
      }
      window.WeiwoJSBridge.call('addCalendarEvent', params)
    },
    goBack() {
      this.$router.back()
    },
    // 提交
    submit() {
      if (this.submitFlag) {
        toast('提交信息中，请勿重复提交')
        return
      }

      this.$refs.detailContent.resetState()
      // 维修类型（1-预约，2-寄修，3-上门维修，6-同城快修）
      if (this.repairType == 1) {
        this.appointmentSubmit()
      }
      if (this.repairType == 2) {
        this.repairSubmit()
      }
      if (this.repairType == 3) {
        this.homeRepairSubmit()
      }
      if (this.repairType == 6) {
        this.quickRepairSubmit()
      }
    },
    // 预约提交
    async appointmentSubmit() {
      if (!this.appointmentSite.siteName) {
        toast('当前地区暂无服务网点，您可以尝试使用其他服务')
        return
      }
      if (!this.selectedTime.time) {
        this.$refs.detailContent.repairTimeSelect()
        toast('请完善订单信息')
        return
      }
      if (!this.appointmentOrder.userName) {
        this.$refs.detailContent.userNameSelect()
        toast('请完善订单信息')
        return
      }
      if (!isPhone(this.appointmentOrder.userPhone.trim())) {
        this.$refs.detailContent.userPhoneSelect()
        toast('请输入正确的手机号')
        return
      }
      if (this.showPhoneVerification && !this.appointmentOrder.smsCode.trim()) {
        this.$refs.detailContent.sendCodeWrapCheck()
        toast('请输入验证码')
        return
      }
      if (!this.isAgreed && this.isShowHeader) {
        this.$refs.detailContent.policeAgreeWrapCheck()
        toast('请勾选《vivo官网隐私政策》')
        return
      }
      const params = {
        siteId: this.appointmentSite.id,
        appointmentDate: this.selectedTime.time,
        businessTimeId: this.selectedTime.id,
        userName: this.appointmentOrder.userName,
        userPhone: this.appointmentOrder.userPhone,
        model: this.shopOrder.shopOrderItemNo ? '' : this.selectedModel.id,
        modelName: this.shopOrder.shopOrderItemNo ? '' : this.selectedModel.name,
        faultTypeIdSecond: this.shopOrder.shopOrderItemNo ? '' : this.selectedProblemList.id,
        remark: this.appointmentOrder.remark,
        verificationCode: this.appointmentOrder.smsCode,
        shopOrderItemNo: this.shopOrder.shopOrderItemNo,
        shopOrderNo: this.shopOrder.shopOrderNo,
        token: this.submitToken
      }
      this.submitFlag = true
      let res = await submitAppointmentOrder(params)
      if (res.code == 0) {
        this.$track({
          cfrom: '01|04|080|003',
          type: this.repairType,
          duration: +new Date() - this.begainTime,
          total_duration: +new Date() - this.repairBeginTime
        })
        if (clientEnv.isVivoApp && clientEnv.appVersion >= 3700) {
          // 添加日历回调在200ms左右，为保证成功页提示正常，需要延时跳转
          this.addCalendarEvent()
          setTimeout(() => {
            this.submitFlag = false
            this.$router.replace(`/service/s/repair/success/${this.repairType}/${res.data}`)
          }, 300)
        } else {
          this.$router.replace(`/service/s/repair/success/${this.repairType}/${res.data}`)
        }
      } else {
        this.submitFlag = false
        toast(res.msg)
        await this.getSubmitToken()
      }

      this.changeUserPhoneLimited(params.userPhone)
    },
    // 寄修提交
    async repairSubmit() {
      if (!this.selectedTime.time) {
        this.$refs.detailContent.repairTimeCheck()
        toast('请完善订单信息')
        return
      }
      if (!this.pickupAddress.receiverName) {
        this.$refs.detailContent.repairSendAddressCheck()
        toast('请完善订单信息')
        return
      }
      if (!this.sendReapairSite.siteName) {
        toast('当前地区暂无服务网点，您可以尝试使用其他服务')
        return
      }
      if (!this.isSameAddress && !this.receiveAddress.receiverName.trim()) {
        this.$refs.detailContent.repairReceiveAddressCheck()
        toast('请完善订单信息')
        return
      }
      if (this.showPhoneVerification && !this.sendReapairOrderInfo.smsCode.trim()) {
        this.$refs.detailContent.sendCodeWrapCheck()
        toast('请输入验证码')
        return
      }
      if (!this.isAgreed && this.isShowHeader) {
        this.$refs.detailContent.policeAgreeWrapCheck()
        toast('请勾选《vivo官网隐私政策》')
        return
      }
      const params = {
        siteId: this.sendReapairSite.id,
        siteCode: this.sendReapairSite.siteCode,
        userNameFro: this.pickupAddress.receiverName,
        userPhoneFro: this.pickupAddress.mobilePhone,
        provinceFro: this.pickupAddress.province,
        cityFro: this.pickupAddress.city,
        areaFro: this.pickupAddress.area,
        addressFro:
          this.pickupAddress.province +
          this.pickupAddress.city +
          this.pickupAddress.area +
          this.pickupAddress.detailAddress,
        userNameTo: this.isSameAddress
          ? this.pickupAddress.receiverName
          : this.receiveAddress.receiverName,
        userPhoneTo: this.isSameAddress
          ? this.pickupAddress.mobilePhone
          : this.receiveAddress.mobilePhone,
        provinceTo: this.isSameAddress ? this.pickupAddress.province : this.receiveAddress.province,
        cityTo: this.isSameAddress ? this.pickupAddress.city : this.receiveAddress.city,
        areaTo: this.isSameAddress ? this.pickupAddress.area : this.receiveAddress.area,
        addressTo: this.isSameAddress
          ? this.pickupAddress.province +
            this.pickupAddress.city +
            this.pickupAddress.area +
            this.pickupAddress.detailAddress
          : this.receiveAddress.province +
            this.receiveAddress.city +
            this.receiveAddress.area +
            this.receiveAddress.detailAddress,
        model: this.shopOrder.shopOrderItemNo ? '' : this.selectedModel.id,
        modelName: this.shopOrder.shopOrderItemNo ? '' : this.selectedModel.name,
        faultTypeIdSecond: this.shopOrder.shopOrderItemNo ? '' : this.selectedProblemList.id || '',
        remark: this.sendReapairOrderInfo.remark,
        receiveTimeStr: this.selectedTime.time,
        verificationCode: this.sendReapairOrderInfo.smsCode,
        isConfirm: this.hasOldOrder ? 1 : 0,
        shopOrderItemNo: this.shopOrder.shopOrderItemNo,
        shopOrderNo: this.shopOrder.shopOrderNo,
        token: this.submitToken
      }
      this.submitFlag = true
      let res = await submitRepairOrder(params)
      if (res.code == 0) {
        this.$track({
          cfrom: '01|04|080|003',
          type: this.repairType,
          duration: +new Date() - this.begainTime,
          total_duration: +new Date() - this.repairBeginTime
        })
        this.$router.replace(`/service/s/repair/success/${this.repairType}/${res.data}`)
      } else {
        toast(res.msg)
        await this.getSubmitToken()
      }
      this.submitFlag = false

      this.changeUserPhoneLimited(params.userPhoneFro)
    },
    // 上门维修提交
    async homeRepairSubmit() {
      if (!this.homeReapairOrderInfo.imeiCode.trim()) {
        this.$refs.detailContent.iemiCodeCheck()
        toast('请完善订单信息')
        return
      }
      if (!this.pickupAddress.receiverName) {
        this.$refs.detailContent.repairSendAddressCheck()
        toast('请完善订单信息')
        return
      }
      if (!this.selectedTime.showTime) {
        this.$refs.detailContent.repairTimeWrapCheck()
        toast('请完善订单信息')
        return
      }
      if (!this.homeReapairSite.siteName) {
        toast('当前地区和时间暂无服务网点，您可以尝试使用其他服务')
        return
      }
      if (this.showPhoneVerification && !this.homeReapairOrderInfo.smsCode) {
        this.$refs.detailContent.sendCodeWrapCheck()
        toast('请输入验证码')
        return
      }
      if (!this.isAgreed && this.isShowHeader) {
        this.$refs.detailContent.policeAgreeWrapCheck()
        toast('请勾选《vivo官网隐私政策》')
        return
      }
      const params = {
        siteCode: this.selectedTime.siteCode,
        province: this.pickupAddress.province,
        city: this.pickupAddress.city,
        area: this.pickupAddress.area,
        address:
          this.pickupAddress.province +
          this.pickupAddress.city +
          this.pickupAddress.area +
          this.pickupAddress.detailAddress,
        onsiteDate: this.selectedTime.day,
        onsiteTime: this.selectedTime.newTimeslot,
        productId: this.selectedModel.id,
        productName: this.selectedModel.name,
        imei: this.homeReapairOrderInfo.imeiCode,
        faultTypeIdSecond: this.selectedProblemList.id || '',
        faultDetail: this.homeReapairOrderInfo.remark,
        userName: this.pickupAddress.receiverName,
        userPhone: this.pickupAddress.mobilePhone,
        verificationCode: this.homeReapairOrderInfo.smsCode,
        token: this.submitToken
      }
      this.submitFlag = true
      let res = await submitOnsiteOrder(params)
      if (res.code == 0) {
        this.$track({
          cfrom: '01|04|080|003',
          type: this.repairType,
          duration: +new Date() - this.begainTime,
          total_duration: +new Date() - this.repairBeginTime
        })
        this.$router.replace(`/service/s/repair/success/${this.repairType}/${res.data}`)
      } else {
        toast(res.msg)
        await this.getSubmitToken()
      }
      this.submitFlag = false

      this.changeUserPhoneLimited(params.userPhone)
    },
    // 同城快修提交
    async quickRepairSubmit() {
      if (!this.selectedTime.time) {
        this.$refs.detailContent.repairTimeCheck()
        toast('请完善订单信息')
        return
      }
      if (!this.quickRepairSendAddressInfo.receiverName) {
        this.$refs.detailContent.repairSendAddressCheck()
        toast('请完善订单信息')
        return
      }
      if (!this.isSameAddress && !this.quickRepairReceiveAddressInfo.receiverName) {
        this.$refs.detailContent.repairReceiveAddressCheck()
        toast('请完善订单信息')
        return
      }
      if (!this.QuickRepairSite) {
        toast('当前地区暂无服务网点，您可以尝试使用其他服务')
        return
      }
      if (this.showPhoneVerification && !this.quickRepairOrderInfo.smsCode.trim()) {
        this.$refs.detailContent.sendCodeWrapCheck()
        toast('请输入验证码')
        return
      }
      if (!this.isAgreed && this.isShowHeader) {
        this.$refs.detailContent.policeAgreeWrapCheck()
        toast('请勾选《vivo官网隐私政策》')
        return
      }
      const params = {
        siteId: this.QuickRepairSite.id,
        siteCode: this.QuickRepairSite.siteCode,
        userNameFro: this.quickRepairSendAddressInfo.receiverName,
        userPhoneFro: this.quickRepairSendAddressInfo.mobilePhone,
        provinceFro: this.quickRepairSendAddressInfo.mapLocationPickupAddress.province,
        cityFro: this.quickRepairSendAddressInfo.mapLocationPickupAddress.city,
        areaFro: this.quickRepairSendAddressInfo.mapLocationPickupAddress.area,
        addressFro:
          this.quickRepairSendAddressInfo.mapLocationPickupAddress.province +
          this.quickRepairSendAddressInfo.mapLocationPickupAddress.city +
          this.quickRepairSendAddressInfo.mapLocationPickupAddress.area +
          this.quickRepairSendAddressInfo.mapLocationPickupAddress.detailAddress,
        userNameTo: this.isSameAddress
          ? this.quickRepairSendAddressInfo.receiverName
          : this.quickRepairReceiveAddressInfo.receiverName,
        userPhoneTo: this.isSameAddress
          ? this.quickRepairSendAddressInfo.mobilePhone
          : this.quickRepairReceiveAddressInfo.mobilePhone,
        provinceTo: this.isSameAddress
          ? this.quickRepairSendAddressInfo.mapLocationPickupAddress.province
          : this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.province,
        cityTo: this.isSameAddress
          ? this.quickRepairSendAddressInfo.mapLocationPickupAddress.city
          : this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.city,
        areaTo: this.isSameAddress
          ? this.quickRepairSendAddressInfo.mapLocationPickupAddress.area
          : this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.area,
        addressTo: this.isSameAddress
          ? this.quickRepairSendAddressInfo.mapLocationPickupAddress.province +
            this.quickRepairSendAddressInfo.mapLocationPickupAddress.city +
            this.quickRepairSendAddressInfo.mapLocationPickupAddress.area +
            this.quickRepairSendAddressInfo.mapLocationPickupAddress.detailAddress
          : this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.province +
            this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.city +
            this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.area +
            this.quickRepairReceiveAddressInfo.mapLocationPickupAddress.detailAddress,
        model: this.selectedModel.id,
        modelName: this.selectedModel.name,
        remark: this.quickRepairOrderInfo.remark,
        receiveTimeStr: this.selectedTime.time,
        faultTypeIdSecond: this.selectedProblemList.id || '',
        newEstimatedPrice:
          Number(this.QuickRepairSite.pickupFee) + Number(this.QuickRepairSite.sendFee),
        newLatitudeAndLongitude: `${this.QuickRepairSite.longitude},${this.QuickRepairSite.latitude}`,
        newExpectedArrivalTime: this.selectedTime.time,
        verificationCode: this.quickRepairOrderInfo.smsCode,
        token: this.submitToken
      }
      this.submitFlag = true
      let res = await submitQuickPickupOrder(params)
      if (res.code == 0) {
        this.$track({
          cfrom: '01|04|080|003',
          type: this.repairType,
          duration: +new Date() - this.begainTime,
          total_duration: +new Date() - this.repairBeginTime
        })
        this.$router.replace(`/service/s/repair/success/${this.repairType}/${res.data}`)
      } else {
        toast(res.msg)
        await this.getSubmitToken()
      }
      this.submitFlag = false

      this.changeUserPhoneLimited(params.userPhoneTo)
    }
  }
}
</script>

<style lang="scss" scoped>
.repair-detail {
  position: relative;
  box-sizing: border-box;
  padding: 0 0 78px;
  min-height: 100vh;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .split-line {
    position: absolute;
    height: 1px;
    z-index: -1;
    bottom: 0px;
    left: 0;
    width: 100%;
  }

  .repair-detail-content {
    padding: 16px 0 0;
    box-sizing: border-box;
    flex: 1;
    overflow-y: auto;
    position: relative;
  }

  .bottom-bar-fixed {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 2;
    height: 78px;
    background: #fff;
    padding: 0 16px;
    box-sizing: border-box;
    border-top: 1px solid #f5f5f5;
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 320px;
    transition: background 0.3s ease;

    .vivo-dark-mode & {
      background-color: #fff;
      border-color: rgba(255, 255, 255, 0.15);
    }

    &.bottom-bar {
      position: absolute;
      background: transparent;

      .bottom-button-left {
        background: rgba(0, 0, 0, 0.04);
      }
    }

    .bottom-button-left {
      font-size: 16px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 156px;
      height: 46px;
      border-radius: 82px;
      background: #fafafa;
      color: #333;

      .vivo-dark-mode & {
        background-color: #282828;
      }
    }

    .bottom-button-submit {
      margin-left: 16px;
      font-size: 16px;
      font-weight: 500;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 156px;
      height: 46px;
      border-radius: 82px;
      color: #fff;
      background-color: #415fff;

      &.all-line {
        width: 264px;
        margin-left: 0;
      }

      .vivo-dark-mode & {
        background-color: #3a56e6;
      }

      &.popup-button-disabled {
        opacity: 0.3;
      }
    }
  }
}

.dialog-content {
  .dialog-content-item {
    .item-title {
      color: #999;
      line-height: 21px;
    }

    .item-content {
      color: #333;
      line-height: 21px;
    }

    &.item-space {
      margin-bottom: 20px;
    }
  }
}
</style>
<style lang="scss">
// vos error组件样式覆盖
.nx-empty {
  &__image {
    margin: 0 auto;
    width: 62px;
    height: 62px;
    &-content {
      width: 100%;
      height: 100%;
    }
  }
  &__image__novideo {
    width: 300px;
  }
  &__desc {
    font-size: 20px;
    line-height: 20px;
    margin: 18px auto;
  }
  .btn-group {
    margin-top: 27px;
    .nx-button {
      font-size: 16px;
      width: 108px;
      height: 47px;
      border-radius: 40px;
      border: 3px solid #456fff;
      padding: 0 10px;
    }
  }
}
</style>
